// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"articleSquare-module--wrapper--3dGOX","block":"articleSquare-module--block--UJLNR"};